module.exports = {
	sensor: require('./sensor.js'),
	'sensor-local-variance': require('./sensor-local-variance'),
	'sensor-projected': require('./sensor-projected'),
};
